import type { ReactNode } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { themePalette } from 'styles/colors/themePalette';
import breakpoints from './breakpoints';
import components from './components';
import { boxShadow, shadows } from './shadows';
import shape from './shape';
import spacing from './spacing';
import transitions from './transitions';
import typography from './typography';

const themeOptions = {
  breakpoints,
  components,
  palette: themePalette,
  shadows,
  boxShadow,
  shape,
  spacing,
  transitions,
  typography,
};

const theme = createTheme(themeOptions);

export function CustomThemeProvider({ children }: { children: ReactNode }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
